import * as React from 'react'
import { IWish } from 'types'
import { Link } from 'react-router-dom'

interface CardProps {
  wish: IWish & { imageSrc: string }
}

const Card: React.SFC<CardProps> = ({ wish }) => {
  return (
    <Link
      to={`/category/${wish.type}`}
      style={{
        width: '46%',
        marginTop: '20px',
        background: 'rgba(255, 255, 255, 0.9)',
        border: '1px solid #BCBCBC',
        boxSizing: 'border-box',
        borderRadius: '5px',
        color: 'black',
        fontSize: 16,
        textDecoration: 'none',
        fontWeight: 'bold',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src={wish.imageSrc}
          style={{
            marginTop: '10px',
            width: '40%',
            height: 'auto',
          }}
        />
        <div style={{ padding: '10px', textAlign: 'center' }}>{wish.name}</div>
      </div>
    </Link>
  )
}

export default Card



// WEBPACK FOOTER //
// ./src/components/cards/Card.tsx